{
    "ko": "지원이 마감되었습니다.",
    "en": "Applications are now closed.",
    "zh-CN": "报名已截止。",
    "zh-TW": "報名已截止。",
    "ja": "応募が終了されました。"
}
